import { render, staticRenderFns } from "./WirelessModulesForm.vue?vue&type=template&id=15b50ffa&"
import script from "./WirelessModulesForm.vue?vue&type=script&lang=js&"
export * from "./WirelessModulesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports